























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DatePicker from "@/components/common/Inputs/DatePicker.vue";
import Navbar from "@/components/common/Navbar.vue";
import DataTable from "@/components/common/Tables/DataTable.vue";
import SideDrawer from "@/components/common/SideDrawer.vue";
import TextButton from "@/components/common/Buttons/TextButton.vue";
import { ILink, ITableHeader } from "@/interfaces/common";
import { IChannel } from "@/interfaces/Distributor";
import Illustration from "@/components/common/Illustration.vue";
import DistributorSegmentchannelService from "@/services/DistributorSegmentchannelService";
import Snackbar from "@/components/common/Snackbar.vue";
import ActionablePopup from "@/components/common/Popup/ActionablePopup.vue";
import SearchBar from "@/components/common/SearchBar.vue";

@Component({
  components: {
    SearchBar,
    Navbar,
    DataTable,
    SideDrawer,
    Illustration,
    DatePicker,
    Snackbar,
    ActionablePopup,
    TextButton,
  },
})
export default class Create extends Vue {
  private description: string = "No Channel Found";
  private subdescription: string = "Please create Channel to begin with";
  private showChannelList: boolean = true;
  private ChannelLoading: boolean = false;
  private createChannels: boolean = true;
  private sideDrawer: boolean = false;
  private timeout!: NodeJS.Timeout;
  private valid: boolean = false;
  private message: string = "";
  private snackbar: boolean = false;
  private sidedrawerTitle: string = "Add Channel";
  private totalChannels: number = 0;
  private menuItems: Array<ILink> = [];
  private pages: number = 0;
  private page: number = 1;
  private selectedChannelId: number = 0;
  private selectedActionMenu: number = -1;
  private creatingOrViewingChannel: boolean = false;
  private channels: Array<IChannel> = [];
  private inactiveChannels: boolean = false;
  private snackbarColor: string = "success";
  private viewItem: IChannel = {
    id: 0,
    name: "",
    erpid: "",
    isDeleted: false,
    isDeactive: false,
  };
  private defaultItem: IChannel = {
    id: 0,
    name: "",
    erpid: "",
    isDeleted: false,
    isDeactive: false,
  };
  private editedItem: IChannel = {
    id: 0,
    name: "",
    erpid: "",
    isDeleted: false,
    isDeactive: false,
  };

  private tableHeaders: Array<ITableHeader> = [
    {
      text: "Name",
      value: "name",
      sortable: true,
      default: "",
    },
    {
      text: "ERPId",
      value: "erpid",
      sortable: true,
      default: "",
    },

    {
      text: "Actions",
      value: "actions",
      sortable: false,
      default: "",
    },
  ];
  private confirmationPopup: boolean = false;
  private confirmationPopupTitle: string = "";
  private confirmationPopupSubtitle: string = "";
  private confirmationPopupText: string = "";
  private cancelBtnText: string = "";
  private confirmBtnText: string = "";

  get formValidate(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }
  get formReset(): Vue & { reset: () => void } {
    return this.$refs.form as Vue & { reset: () => void };
  }
  get formResetValidation(): Vue & { resetValidation: () => void } {
    return this.$refs.form as Vue & { resetValidation: () => void };
  }
 
  public openDrawer(value: string): void {
    this.sidedrawerTitle = this.createChannels
      ? "Fill Channel Details"
      : "View Channel Details";
    this.clearForm();
    this.sideDrawer = true;
    this.formResetValidation.resetValidation();
  }
  public closeSideDrawer(value: boolean): void {
    this.hideWindowScrollBar(value);
    this.sideDrawer = value;
  }
  public editChannel(value: IChannel): void {
    this.createChannels = false;
    this.openDrawer("");
    this.editedItem = Object.assign(
      {},
      {
        name: value.name,
        erpid: value.erpid,
        id: value.id,
        isDeleted: false,
        isDeactive: false,
      }
    );
  }
  public updateChannel(): void {
    let value = Object.assign({}, this.editedItem);
    this.creatingOrViewingChannel = true;
    DistributorSegmentchannelService.UpdateChannel({
      name: value.name,
        erpid: value.erpid,
        id: value.id,
        isDeleted: false,
        isDeactive: false,
    })
      .then((response: any) => {
        this.snackbarColor = "success";
        this.snackbar = true;
        this.message = "Changes Saved Successfully";
        this.showChannelList = true;
        this.creatingOrViewingChannel = false;
        this.closeSideDrawer(false);
        this.clearForm();
        this.refreshChannelList();
      })
      .catch((error: { response: { status: number; data: string } }) => {
        this.creatingOrViewingChannel = false;
        if (error.response.status == 400) {
          this.snackbarColor = "red";
          this.snackbar = true;
          this.message = error.response.data;
        }
      });
  }

  public async getChannel(
    page: number
  ): Promise<boolean> {
    debugger;
    this.ChannelLoading = true;
    return new Promise<boolean>((res) => {
      DistributorSegmentchannelService.GetDistributorChannels(page)
        .then((response) => {
          this.channels = response.data.channels;
          this.pages = response.data.pages;
          this.totalChannels = response.data.total;
          this.ChannelLoading = false;
          if (this.channels.length > 0) {
            this.showChannelList = true;
          } else {
            this.showChannelList = false;
            this.description =
              
                 "No Channel Found";
            this.subdescription =
              this.channels.length == 0
                ? "Please create a Channel to begin with"
                : "No Channel Found ";
          }
          res(true);
        })
        .catch((error) => {
          this.showCommunicationError(error);
          console.log(error);
          this.ChannelLoading = false;
        });
    });
  }
  public showCommunicationError(err: any) {
    this.snackbarColor = "red";
    this.snackbar = true;
    this.message = window.navigator.onLine
      ? `Some Error occured`
      : `Cannot reach server at the moment`;
  }
  private async GetMenuActions(): Promise<void> {
    this.menuItems = [
      {
        Text: "DEACTIVATE",
        Color: "red",
      },
    ];
  }

  public createNewChannel(): void {
    let value = Object.assign({}, this.editedItem);
    this.creatingOrViewingChannel = true;
    DistributorSegmentchannelService.createChannel({
        name: value.name,
        erpid: value.erpid,
        id: value.id,
        isDeleted: false,
        isDeactive: false,
    })
      .then((response) => {
        this.snackbarColor = "success";
        this.snackbar = true;
        this.message = "Channel Created Successfully";
        this.showChannelList = true;
        this.creatingOrViewingChannel = false;
        this.closeSideDrawer(false);
        this.clearForm();
        this.refreshChannelList();
      })
      .catch((error) => {
        this.creatingOrViewingChannel = false;
        if (error.response.status == 400) {
          this.snackbarColor = "red";
          this.snackbar = true;
          this.message = "Please Fill Required(*)/Mandatory Field";
        }
      });
  }

  
  public async getInactiveChannel(): Promise<boolean> {
    this.ChannelLoading = true;
    return new Promise<boolean>((res) => {
      DistributorSegmentchannelService.getInactiveChannel(this.page)
        .then((response) => {
          this.channels = response.data.channels;
          this.pages = response.data.pages;
          this.totalChannels = response.data.total;
          this.ChannelLoading = false;
          if (this.channels.length > 0) {
            this.showChannelList = true;
          } else {
            this.showChannelList = false;
            this.description =
              this.channels.length == 0
                ? "No Inactive Channel Found"
                : "No matching result found";
            
          }
          res(true);
        })
        .catch((error) => {
          this.showCommunicationError(error);
          console.log(error);
          this.ChannelLoading = false;
        });
    });
  }
  public switchChannels() {
    if (this.inactiveChannels) {
      this.tableHeaders = [
        {
          text: "Name",
          value: "name",
          sortable: true,
          default: "",
        },
        {
          text: "ERPId",
          value: "erpid",
          sortable: true,
          default: "",
        },

        {
          text: "Actions",
          value: "actions",
          sortable: false,
          default: "",
        },
      ];
      this.getInactiveChannel();
    } else {
      this.tableHeaders = [
        {
          text: "Name",
          value: "name",
          sortable: true,
          default: "",
        },
        {
          text: "ERPId",
          value: "erpid",
          sortable: true,
          default: "",
        },

        {
          text: "Actions",
          value: "actions",
          sortable: false,
          default: "",
        },
      ];
      this.getChannel(1);
    }
  }
  public changePage(value: number): void {
    this.page = value;
    this.inactiveChannels
      ? this.getInactiveChannel()
      : this.getChannel(value);
  }

  public clearForm(): void {
    this.editedItem = Object.assign({}, this.defaultItem);
  }
  private hideWindowScrollBar(hideIt: boolean) {
    window.document.documentElement.style.overflowY = hideIt
      ? "hidden"
      : "scroll";
  }
  public actionablePopup() {
    this.snackbar = true;
    this.confirmationPopup = false;
    this.showChannelList = true;
  }
  public closeSnackbar(value: boolean): void {
    this.snackbar = value;
  }
  private createOrViewChannel(): void {
    if (!this.creatingOrViewingChannel) this.createChannels ? this.createNewChannel() : this.updateChannel();
  }
  public async refreshChannelList() {
    this.inactiveChannels
      ? await this.getInactiveChannel()
      : await this.getChannel( 1);
  }
    public menuAction(channel: IChannel, commandIndex: number){
           this.selectedChannelId = channel.id;
           this.selectedActionMenu = commandIndex;
           switch (this.menuItems[commandIndex].Text) {
            case "DEACTIVATE": 
                        this.confirmationPopupTitle = "Confirm Deactivation";
                        this.confirmationPopupSubtitle = "Are you sure you wish to deactivate the " + channel.name + " Channel?";
                        this.confirmationPopupText = "";
                        this.cancelBtnText = "Cancel";
                        this.confirmBtnText = "Confirm";
                        this.confirmationPopup = true;
                    break;
                default: console.log("Unhandled menuAction")
            }
        }
    public activateChannel(channel: IChannel){
            this.selectedChannelId = channel.id;
            this.confirmationPopupTitle = "Confirm Activation";
            this.confirmationPopupSubtitle = channel.name+" Channel will be activated.";
            this.confirmationPopupText = "";
            this.cancelBtnText = "Keep Inactive";
            this.confirmBtnText = "Activate";
            this.confirmationPopup = true;
        }

  public confirmAction(value: any): void {
    if (this.inactiveChannels) {
      DistributorSegmentchannelService.activateChannel(value)
        .then((res) => {
          this.snackbarColor = "success";
          this.message = "Changes Saved Successfully";
          this.actionablePopup();
          this.switchChannels();
        })
        .catch((err: any) => {
          this.showCommunicationError(err);
          console.log(err);
        });
    } else {
      DistributorSegmentchannelService.deactivateChannel(value)
        .then((res) => {
          this.snackbarColor = "red";
          this.message = "Channel deactivated and moved to inactive list";
          this.actionablePopup();
          this.refreshChannelList();
        })
        .catch((err) => {
          this.showCommunicationError(err);
          console.log(err);
        });
    }
  }
  async created() {
    this.ChannelLoading = true;
    this.getChannel(1);
    this.GetMenuActions().then((_) => _);
  }
}
